import {get, flatten, map} from 'lodash';
import React, {Component} from 'react';
import {FastField, ErrorMessage, getIn} from 'formik';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';
import {generateNextChoiceId} from '../../../services/idHelpers';
import MinusButton from './MinusButton';
import PlusButton from './PlusButton';
import UpButton from './UpButton';
import DownButton from './DownButton';
import Error from '../../Error';
import DraggableCell from './DraggableCell';
import DraggableRow from './DraggableRow';
import DragDropTableBody from './DragDropTableBody';
import ScriptGeneratorClassifier2ChoicesButton from './ScriptGeneratorClassifier2ChoicesButton';
import ScriptGeneratorClassifier2ChoicesLabel from './ScriptGeneratorClassifier2ChoicesLabel';


class GeneratorClassifier2ChoiceType extends Component {
    constructor(props) {
        super(props);
        this.addChoice = this.addChoice.bind(this);
        this.move = this.move.bind(this);
    }

    addChoice() {
        const choices = get(this.props.form.values, this.props.name);
        this.props.push({id: generateNextChoiceId(choices), value: '', choiceScripts: []});
    }

    move(from, to) {
        const {move, form, name} = this.props;
        move(from, to);
        form.setFieldTouched(`${name}.${from}.choiceScripts.0.expression.0.id`, true, false);
        form.setFieldTouched(`${name}.${to}.choiceScripts.0.expression.0.id`, true, false);
        form.validateField(`${name}.${from}.choiceScripts`);
    }

    render() {
        const {remove, form, name, currPage, parameters, extraFields} = this.props;
        const items = flatten(map(form.values.editor.pages, 'items'));

        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col style={{width: 120}} />
                    <col />
                    <col style={{width: 50}} />
                    <col />
                    <col />
                    <col style={{width: 50}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.choiceId} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th>
                        <th colSpan={2}>Condizioni</th>
                        <th />
                    </tr>
                </thead>
                <DragDropTableBody move={this.move}>
                    {get(form.values, name) && get(form.values, name).map((item, index, arr) => (
                        <DraggableRow item={item} index={index} key={index}>
                            <DraggableCell className="pl-0">
                                <FastField id={`${name}.${index}.id`} name={`${name}.${index}.id`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.id`) && get(form.touched, `${name}.${index}.id`)})} />
                                <ErrorMessage name={`${name}.${index}.id`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField id={`${name}.${index}.value`} name={`${name}.${index}.value`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.value`) && get(form.touched, `${name}.${index}.value`)})} />
                                <ErrorMessage name={`${name}.${index}.value`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <ScriptGeneratorClassifier2ChoicesButton currPage={currPage} id={`${name}.${index}.choiceScripts`}
                                    form={form} isLastChoice={index === arr.length - 1} />
                            </DraggableCell>
                            <DraggableCell>
                                {
                                    get(form.values, `${name}.${index}.choiceScripts`) &&
                                    <ScriptGeneratorClassifier2ChoicesLabel
                                        hasError={!!getIn(form.touched, `${name}.${index}.choiceScripts`) &&
                                            !!getIn(form.errors, `${name}.${index}.choiceScripts`)}
                                        id={`${name}.${index}.choiceScripts`}
                                        name={`${name}.${index}.choiceScripts`}
                                        scripts={get(form.values, `${name}.${index}.choiceScripts`)}
                                        items={items}
                                        parameters={parameters}
                                        extraFields={extraFields}
                                    />
                                }
                            </DraggableCell>
                            <DraggableCell className="border-right">
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <div className="">{index > 0 && <UpButton move={this.move} index={index} />}</div>
                                        <div className="">{index + 1 < arr.length && <DownButton move={this.move} index={index} />}</div>
                                    </div>
                                </div>
                            </DraggableCell>
                            <DraggableCell>
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <MinusButton remove={remove} index={index} />
                                    </div>
                                </div>
                            </DraggableCell>
                        </DraggableRow>
                    ))}
                </DragDropTableBody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <PlusButton onClick={this.addChoice}>
                                <FormattedMessage {...messages.surveys.button.add_choice} />
                            </PlusButton>
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }
}

export default GeneratorClassifier2ChoiceType;
